// El detalle de un pedido, como lo ve el local.
//
// Lo usan dos pantallas: "Mis pedidos" (boton Ver detalle) y "Mi cuenta"
// (tocando la compra de un dia). Estaba escrito solo en la primera; al pedir
// lo mismo desde la cuenta se saco aca en vez de copiarlo.
//
// El endpoint valida que el pedido sea de un local de la sesion, asi que desde
// el navegador no hay forma de mirar el de otro local.

import { api } from "../api";
import { formatearPesos } from "../../lib/money";
import { nombreTurno } from "../../lib/types";
import type { LineaDeLocal, Turno } from "../../lib/types";

function esc(s: unknown): string {
  return String(s ?? "").replace(/[&<>"]/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] as string,
  );
}

/** Datos del encabezado. Todos opcionales: la cuenta sabe menos que Mis pedidos. */
export interface CabezalPedido {
  fecha_entrega?: string | null;
  turno?: Turno | null;
}

export async function abrirDetalleLocal(
  dlg: HTMLDialogElement,
  id: number,
  cabezal: CabezalPedido = {},
): Promise<void> {
  dlg.innerHTML = `<div class="tarjeta w-[26rem] max-w-full border-0 shadow-none text-masa-400">Cargando...</div>`;
  dlg.showModal();

  let lineas: LineaDeLocal[];
  try {
    ({ lineas } = await api.get<{ lineas: LineaDeLocal[] }>(`/api/cliente/pedidos/${id}`));
  } catch (e) {
    dlg.innerHTML = `
      <div class="tarjeta w-[24rem] max-w-full border-0 shadow-none">
        <p class="text-red-700">${esc(e instanceof Error ? e.message : "Error")}</p>
        <div class="mt-4 flex justify-end"><button id="cerrar" class="btn-primario">Cerrar</button></div>
      </div>`;
    dlg.querySelector("#cerrar")?.addEventListener("click", () => dlg.close());
    return;
  }

  const total = lineas.reduce((s, l) => s + l.subtotal, 0);
  const cuando = [
    cabezal.fecha_entrega ? `entrega ${esc(cabezal.fecha_entrega)}` : "",
    cabezal.turno ? esc(nombreTurno(cabezal.turno)) : "",
  ]
    .filter(Boolean)
    .join(" · ");

  dlg.innerHTML = `
    <div class="tarjeta w-[26rem] max-w-full border-0 shadow-none">
      <h2 class="text-lg font-bold">Pedido #${esc(id)}</h2>
      ${cuando ? `<p class="mb-3 text-sm text-masa-500">${cuando}</p>` : `<div class="mb-3"></div>`}
      <div class="max-h-[60vh] overflow-y-auto">
        ${lineas
          .map(
            (l) => `<div class="flex items-center justify-between gap-2 border-t border-crema-100 py-2 text-sm">
              <span class="min-w-0 flex-1">${esc(l.descripcion)}</span>
              <span class="shrink-0 text-masa-500">${esc(l.cantidad)} ×</span>
              <span class="w-20 shrink-0 text-right tabular-nums">${formatearPesos(l.subtotal)}</span>
            </div>`,
          )
          .join("")}
        <div class="flex items-center justify-between gap-2 border-t-2 border-crema-200 py-2 text-sm font-bold">
          <span>Total</span>
          <span class="tabular-nums">${formatearPesos(total)}</span>
        </div>
      </div>
      <div class="mt-4 flex justify-end"><button id="cerrar" class="btn-primario">Cerrar</button></div>
    </div>`;
  dlg.querySelector("#cerrar")?.addEventListener("click", () => dlg.close());
}
